import { Close } from '@radix-ui/react-dialog'
import type { ComponentPropsWithoutRef } from 'react'

type CloseProps = ComponentPropsWithoutRef<typeof Close>

export interface SheetCloseProps extends CloseProps {
  asChild?: CloseProps['asChild']
  className?: CloseProps['className']
}

export const SheetClose = Close
